module.exports = __webpack_public_path__ + "img/progress-indicator-background.19faf020.png";